import { SECTION_TYPES } from '@/content/values/sections';
import { Section } from '@/courses/models/section.model';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { TEACHER_WIDGET_TASK_TABS, _HOMEWORKS_STORE } from '@/homework/values/homeworks.values';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { Component, Vue } from 'vue-property-decorator';
import { IRequestSetDraftHomework } from '../interfaces/request-set-draft-homework.interface';
import { IRequestSetFeedbacDraft } from '../interfaces/request-set-feedback-draft.interface';
import { IRequestSetHomework } from '../interfaces/request-set-homework.interface';
import { WidgetTeacherHomework } from '../models/widget-teacher-homework.model';
import { WidgetTeacherPerson } from '../models/widget-teacher-person.model';
import KEYS from '@/values/keys';
import { HomeworksService } from '@/homework/services/homeworks.service';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import Course from '@/content/models/course.model';
import i18n from '@/content/lang/content.i18n';


@Component({})
export class HomeworkMixin extends Vue {

  get isPresentationMode() : boolean{
    return this.$store.state.CourseStore.isPresentationStudentMode || this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  get course(): Course {
    return this.$store.state.HomeworksStore.teacherWidgetTabSelected == TEACHER_WIDGET_TASK_TABS.BY_STUDENT ?
     this.$store.state.HomeworksStore.teacherWidgetHomeworks.courseOpened : 
     this.$store.state.HomeworksStore.teacherWidgetHomeworksSection.courseOpened;
  }

  get offlineMode() : boolean {
    return this.$store.state.AppStore.offlineMode;
  }

  createStudentHomework(courseId: number, req: IRequestSetHomework, file?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.$store.dispatch(_HOMEWORKS_STORE.ACTIONS.SET_STUDENT_HOMEWORK_RESPONSE, { req, file }).then(() => {
        this.updateHomeworkState(courseId, req.sectionId, resolve);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  createStudentDraftHomework(
      courseId: number,
      homework: IRequestSetDraftHomework,
      file?: any,
      refresh: boolean = true): Promise<WidgetTeacherHomework> {
    return new Promise((resolve, reject) => {
      let req: any = { homework };
      if(file) req.file = file;
      this.$store.dispatch(_HOMEWORKS_STORE.ACTIONS.SET_DRAFT_HOMEWORK, req).then((res) => {
        let draft = new WidgetTeacherHomework(res);
        this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.UPDATE_STUDENT_HOMEWORK_DRAFT, {
          courseId, sectionId: homework.sectionId, draft
        });
        if(this.$store.state.CourseStore.courses.content.length > 0 && refresh) {
          this.$edEventBus.$emit(COURSES_EVENTS.REFRESH_WIDGET_COURSE, {courseId});
        }
        this.$EdToast.update({ 
          msg: `${this.$i18n.t('common.saved')}`,
          type: TOAST_TYPES.SUCCESS,
          timeout: 1000
        });
        resolve(draft);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  private updateHomeworkState(courseId: number, sectionId: number, resolve):void{

    this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.REMOVE_STUDENT_HOMEWORK, { 
      courseId: courseId,
      sectionId: sectionId
    });

    if(this.$store.state.CourseStore.courses.content.length > 0) {
      this.$edEventBus.$emit(COURSES_EVENTS.REFRESH_WIDGET_COURSE, { courseId });
    }

    this.$edEventBus.$emit(
      SCREEN_MIRRORING_EVENTS.CLICK,
      this,
      {
        target: SCREEN_MIRRORING_EVENTS.ON_REFRESH_COURSE,
        courseId,
        sectionId
      }
    );

    this.$EdToast.update({ 
      msg: `${this.$i18n.t('common.sent')}`,
      type: TOAST_TYPES.SUCCESS,
      timeout: 1000
    });

    resolve(`${courseId}${sectionId}`);
    
  }

  getHomeworkViewer(homework: any, key: string = 'viewerHomework') {
    let section: Section = homework.section;
    let viewer = SECTION_TYPES[section.type].viewerHomework;
    switch(section.type) {
      case SECTION_TYPES.LESSON_MATERIAL.code:
        viewer = SECTION_TYPES[homework.type] ? SECTION_TYPES[homework.type][key] : SECTION_TYPES[section.type][key];
      break;
      case SECTION_TYPES.LESSON_EPUB.code:
      case SECTION_TYPES.LESSON_PDF.code:
      case SECTION_TYPES.LESSON_SPLIT_WRITE.code:
      case SECTION_TYPES.LESSON_SPLIT_TYPE.code:
      case SECTION_TYPES.LESSON_DOC.code:
      case SECTION_TYPES.LESSON_DOCX.code:
      case SECTION_TYPES.LESSON_XLS.code:
      case SECTION_TYPES.LESSON_XLSX.code:
      case SECTION_TYPES.LESSON_PPT.code:
      case SECTION_TYPES.LESSON_PPTX.code:
        viewer = SECTION_TYPES[section.type][key];
      break;
      case SECTION_TYPES.LESSON_TEXT.code:
        if(this.isLessonTextRespondedWithPdf(homework)) {
          viewer = SECTION_TYPES[SECTION_TYPES.LESSON_PDF.code][key];
        }
        break;
    }
    return viewer;
  }

  getCanAnswerWithObject(section: Section): boolean {
    switch(section.type) {      
      case SECTION_TYPES.LESSON_SPLIT_TYPE.code:
      case SECTION_TYPES.LESSON_MATERIAL.code:
        return false;
    }
    return true;
  }

  setFeedbackDraft(
    student: WidgetTeacherPerson,
    courseId: number,
    homework: IRequestSetFeedbacDraft,
    file?: any): Promise<void> {
    return new Promise((resolve, reject) => {
      let req: any = { homework };
      if(file) req.file = file;
      this.$store.dispatch(_HOMEWORKS_STORE.ACTIONS.SET_FEEDBACK_DRAFT, req).then((res) => {
        this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.SET_FEEDBACK_DRAFT_IN_HOMEWORK, {
          courseId,
          studentId: homework.responseOwnerId,
          homework: new WidgetTeacherHomework(res)
        });
        this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.REFRESH_PERSON_STATUS, {student, isReload: false});
        this.$EdToast.update({ 
          msg: `${this.$i18n.t('common.saved')}`,
          type: TOAST_TYPES.SUCCESS,
          timeout: 1000
        });
        resolve();
      }).catch((err) => {
        reject(err);
      });
    });
  }

  public validateDraftBoardOptions(section: Section, options : any) : boolean {
    return options.indexOf(section.type) >= 0;
  }

  public showCantOpenHomeworkModal() : void{
    this.$EdModal.createMessageModal({
      title: this.$i18n.t('common.information'),
      body: this.$i18n.t('homeworks.cantOpenHomework'),
      type: KEYS.EVENT_TYPES.WARNING
    });
  }

  private showValidateWhiteboardLoading() : void{ 
    if(!this.$refs.validateWhiteboardLoading){
      return;
    }
    this.$refs.validateWhiteboardLoading['show']();
  }

  private hideValidateWhiteboardLoading() : void{
    if(!this.$refs.validateWhiteboardLoading){
      return;
    }
    this.$refs.validateWhiteboardLoading['hide']();
  }
  
  public obtainUsersMadeAnnotations(boardGroupHash : string) : Promise<any> {   
    this.showValidateWhiteboardLoading();
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        HomeworksService.obtainUsersMadeAnnotations(boardGroupHash)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject();
        })
        .finally(() => this.hideValidateWhiteboardLoading());
      }, 2000);      
    });
  }

  public openModalWithoutAnnotations() : void{
    this.$EdModal.createMessageModal({
      title: this.$i18n.t('common.information'),
      body: this.$i18n.t('homeworks.homeworkWithoutAnnotations'),
      type: KEYS.EVENT_TYPES.WARNING
    });
  }

  public isLessonTextRespondedWithPdf(homework: any): boolean {
    return SECTION_TYPES.LESSON_TEXT.code == homework.section.type &&
        (
            homework.homeworkAssetInfo ||
            SECTION_TYPES.LESSON_PDF.code == homework.type ||
            (homework.response && SECTION_TYPES.LESSON_PDF.code == homework.response.type)
        );
  }

  public getCurrentHomeworkDraft(sectionId: number, studentId: number): Promise<any> {
    return HomeworksService.getCurrentHomeworkDraft(sectionId, studentId);
  }

  public validateHomeworkStatus(hash: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.$store.dispatch(_HOMEWORKS_STORE.ACTIONS.GET_HOMEWORK_CONVERTER_STATUS, hash)
      .then(response => resolve(response))
      .catch(err => reject(err));
    });
  }

}
